import StoneAge from '@/roc/era/StoneAge';
import BronzeAge from '@/roc/era/BronzeAge';
import MinoanEra from '@/roc/era/MinoanEra';
import ClassicGreece from '@/roc/era/ClassicGreece';
import EarlyRome from '@/roc/era/EarlyRome';
import RomanEmpire from '@/roc/era/RomanEmpire';
import ByzantineEra from '@/roc/era/ByzantineEra';
import AgeOfTheFranks from '@/roc/era/AgeOfTheFranks';
import FeudalAge from '@/roc/era/FeudalAge';
import IberianEra from '@/roc/era/IberianEra';
import KingdomOfSicily from "@/roc/era/KingdomOfSicily";
import HighMiddleAges from "@/roc/era/HighMiddleAges";
import EarlyGothicEra from "@/roc/era/EarlyGothicEra";
import LateGothicEra from '@/roc/era/LateGothicEra';
const Eras = {
    stoneAge: StoneAge,
    bronzeAge: BronzeAge,
    minoanEra: MinoanEra,
    classicGreece: ClassicGreece,
    earlyRome: EarlyRome,
    romanEmpire: RomanEmpire,
    byzantineEra: ByzantineEra,
    ageOfTheFranks: AgeOfTheFranks,
    feudalAge: FeudalAge,
    iberianEra: IberianEra,
    kingdomOfSicily: KingdomOfSicily,
    highMiddleAges: HighMiddleAges,
    earlyGothicEra: EarlyGothicEra,
    lateGothicEra: LateGothicEra,
};
export default Eras;
